import React from 'react';
import { useNavigate } from 'react-router';
import { useLocalStorage } from '@rehooks/local-storage';
import { CDEKWarningBanner } from 'components/Banner/CDEKWarningBanner2';
import { SecretSantaBanner } from 'components/Banner/SecretSantaBanner';

export const currentBanner = 'secret-santa-banner-3';
export const currentWidth = 1110;
const link = '/goods/secret_santa';


export const Banner = () => {
    const navigate = useNavigate();
    const [ _showBanner, setShowBanner ] = useLocalStorage(currentBanner, false);

    const onClick = (e) => {
        e.preventDefault();
        setShowBanner(false);
        navigate(link);
    }

    return (
        <SecretSantaBanner onClick={onClick} />
    )
}
